import { IconProps } from '@rsuite/icons/lib/Icon'
import { FC } from 'react'

const ArrowStrokeWhite: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.44194 10.4393L4.8801 7L1.44194 3.56066C0.856153 2.97487 0.856153 2.02513 1.44194 1.43934C2.02773 0.853555 2.97747 0.853555 3.56326 1.43934L8.06326 5.93934C8.28856 6.16464 8.42721 6.44379 8.4792 6.73535L8.5 6.91145L8.5 7.08855C8.4792 7.44241 8.33362 7.7903 8.06326 8.06066L3.56326 12.5607C2.97747 13.1464 2.02773 13.1464 1.44194 12.5607C0.856153 11.9749 0.856153 11.0251 1.44194 10.4393Z"
      fill="#8E8E93"
      stroke="white"
    />
  </svg>
)

export default ArrowStrokeWhite
